var _path, _ellipse, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgLinkedin = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.69 13.86h2.52v8.52h-2.52ZM16.38 13.86h2.23v1.08h.07a6.7 6.7 0 0 1 1.2-.9 2.9 2.9 0 0 1 1.53-.38 2.25 2.25 0 0 1 2 .91 4.35 4.35 0 0 1 .63 2.52v5.29h-2.51v-5a2.33 2.33 0 0 0-.25-1.27.94.94 0 0 0-.8-.35 1.5 1.5 0 0 0-.83.22 4.5 4.5 0 0 0-.75.61v5.75h-2.52Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.95,
    cy: 10.92,
    rx: 1.75,
    ry: 1.76
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1a16 16 0 1 0 16 16A16 16 0 0 0 17 1m0 31a15 15 0 1 1 15-15 15 15 0 0 1-15 15"
  })));
};
const Memo = /*#__PURE__*/memo(SvgLinkedin);
export default Memo;